<template>
  <v-form ref="form" v-model="valid">
    <v-card>
      <v-card-text>
        <v-text-field
          :label="$t('fundReportForm.reportTitle.label')"
          v-model="formData.reportTitle"
          @change="save"
          :placeholder="$t('fund.report.title.final', { year: fund.auditPeriod.year + 1 })"
        ></v-text-field>

        <v-textarea
          :label="$t('fundReportForm.reportDisclaimer.label')"
          v-model="formData.reportDisclaimer"
          @change="save"
          :placeholder="disclaimer"
          auto-grow
        ></v-textarea>

        <v-select
          v-if="labelTypeOptions.length"
          :label="$t('fundReportForm.labelType.label')"
          v-model="formData.labelType"
          :items="labelTypeOptions"
          @change="save"
        ></v-select>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="saved" color="secondary">
      <div class="text-center flex-grow-1">
        {{ $t("action.saved") }}
      </div>
    </v-snackbar>
  </v-form>
</template>

<script>
import UpdateFundMutation from "@/gql/mutations/UpdateFundMutation.gql";
import { getDisclaimer } from "@/utils/getDisclaimer";

export default {
  props: {
    fund: {
      type: Object,
      required: true,
    },
  },

  data() {
    let labelTypeOptions = [];
    if (this.fund.auditPeriod.year >= 2024) {
      labelTypeOptions = [
        { text: this.$t("fundReportForm.labelType.default"), value: "default" },
        { text: this.$t("fundReportForm.labelType.transition"), value: "transition" },
      ];
    }

    return {
      formData: {
        reportTitle: this.fund.reportTitle,
        reportDisclaimer: this.fund.reportDisclaimer,
        labelType: this.fund.labelType || "default",
      },
      labelTypeOptions,
      valid: false,
      loading: false,
      saved: false,
    };
  },

  computed: {
    disclaimer() {
      return getDisclaimer(this.fund);
    },
  },

  methods: {
    async save() {
      this.loading = true;
      await this.update();
      this.loading = false;
      this.saved = true;
    },

    async update() {
      await this.$apollo.mutate({
        mutation: UpdateFundMutation,
        variables: {
          id: this.fund.id,
          input: {
            ...this.formData,
          },
        },
      });
    },
  },
};
</script>
